import { render, staticRenderFns } from "./BudgetsTab.vue?vue&type=template&id=19085d46&scoped=true&"
import script from "./BudgetsTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetsTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetsTab.vue?vue&type=style&index=0&id=19085d46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19085d46",
  null
  
)

export default component.exports